<template>
  <div>
    <Form ref="formValidate" :label-width="125" style="margin:30px">
      <FormItem label="仓库编号" prop="warehouseId">
        <Input :value="sortPalletDto.warehouseId" style="width: 150px;" readonly />
      </FormItem>
      <FormItem label="仓库名称">
        <dict-select :value="sortPalletDto.warehouseId" namespace="bizObjects" id="ValidWarehouse" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="标的物小类" prop="targetType">
        <dict-select :value="sortPalletDto.targetType" namespace="target" id="type" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="用途类型" prop="useType">
        <dict-select :value="sortPalletDto.useType" namespace="ENUM_CORE-STORAGE" id="operateService.UseType" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="分拣总数量" prop="totalNum">
        <Input v-model="sortPalletDto.totalNum" style="width: 150px;" />
      </FormItem>
    </Form>
    <Button type="success" size="small" @click="addLine" style="margin:10px">添加</Button>
    <Table :data="sortList" :columns="columns" border style="width: 900px;">
      <template slot-scope="{ row, index }" slot="targetCode">
        <bizSelect v-if="sortPalletDto.useType === 'RENT'" :value="row.targetCode" @onChange="(val)=>sortList[index].targetCode = val" url="http://CORE-TARGET/messageService/leaseTargetService/queryLeaseTargetCodesByType" :params="{targetType:sortPalletDto.targetType}" codeField="code" style="width:200px" />
        <bizSelect v-else :value="row.targetCode" @onChange="(val)=>sortList[index].targetCode = val" url="http://CORE-TARGET/messageService/baseInfoService/queryTargetsByType" :params="{targetType:sortPalletDto.targetType}" codeField="code" style="width:200px" />
        <!-- <dict-select :value="row.targetCode" @on-change="(val)=>sortList[index].targetCode = val" namespace="target" id="code" :exclusion="[]"/> -->
      </template>
      <template slot-scope="{ row, index }" slot="quality">
        <dict-select :value="row.quality" @on-change="(val)=>sortList[index].quality = val" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="['UNKNOWN']" />
      </template>
      <template slot-scope="{ row, index }" slot="num">
        <InputNumber :value="row.num" @on-change="(val)=>sortList[index].num = val" style="width: 150px;" />
      </template>
      <template #destroyResponsibleMemberId="{row,index}">
        <dict-select namespace="bizObjects" id="member" :value="row.destroyResponsibleMemberId" @on-change="val => sortList[index].destroyResponsibleMemberId = val" :includes="includesList" />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="error" size="small" @click="removeLine(index)">删除</Button>
      </template>
    </Table>

    <div style="text-align:center;width:700px;margin:30px">
      <Button type="success" style="margin-left:20px" @click="commit">提交</Button>
      <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
    </div>
  </div>
</template>
<script>
import dictSelect from "@/components/select/dict-select.vue";
import bizSelect from "@/components/select/biz-select.vue";
export default {
  components: {
    dictSelect,
    bizSelect,
  },
  props: ["paramData"],
  data() {
    return {
      sortPalletDto: {},
      includesList: [],
      sortList: [],
      columns: [
        { title: "标的物", slot: "targetCode" },
        { title: "品质类型", slot: "quality" },
        { title: "数量", slot: "num" },
        { title: "损坏责任参与人", slot: "destroyResponsibleMemberId" },
        { title: "操作", slot: "action" },
      ],
    };
  },
  mounted() {
    this.sortPalletDto = this.paramData;
    this.sortPalletDto.totalNum = "";
    this.getDestroyRespons();
  },
  methods: {
    commit() {
      let total = 0;
      this.sortList.forEach((item) => (total += item.num));
      if (total != this.sortPalletDto.totalNum) {
        this.$Message.error("分拣数量与总数不符!");
        return;
      }
      this.sortPalletDto.sortList = this.sortList;
      let params = {
        url: "http://MID-OPERATE-STORE/messageService/operateService/sortPallet",
        body: this.sortPalletDto,
      };

      this.invoke(params).then((rs) => {
        if (rs) {
          this.sortPalletDto = {};
          this.sortList = [];
          this.$Message.info("分拣成功!");
          this.back();
        }
      });
    },
    async getDestroyRespons() {
      let data = {
        url: "http://CORE-CONTRACT/messageService/billingModelService/queryLeaseeIdsByTargetType",
        body: { targetType: this.sortPalletDto.targetType },
      };
      this.includesList = await this.invoke(data);
    },
    back() {
      this.$emit("on-finish", {});
    },
    addLine() {
      this.sortList.push({ targetCode: "", quality: "", num: "" });
    },
    removeLine(index) {
      this.sortList.splice(index, 1);
    },
  },
};
</script>